// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { GoogleOAuthProvider } from '@react-oauth/google';

/**
 * Application Entry Point
 * 
 * This is where the React app is mounted to the DOM.
 * It wraps the App component and renders it to the root element.
 */
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="790510114818-8gjdhhb8edc5p68i2nu85i3uctjttgla.apps.googleusercontent.com">
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);